/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { objectiveWithKeyResultsSchema } from './objectiveWithKeyResultsSchema';

export const paginationDocumentObjectiveWithKeyResultsSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(objectiveWithKeyResultsSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
